document.addEventListener("DOMContentLoaded", function () {
    window.addEventListener("load", function () {
        let productLists = document.querySelectorAll('.productList');

        if (!productLists.length) {
            return;
        }

        productLists.forEach(function (productList) {
            let buttons = productList.querySelectorAll('button');
            let products = productList.querySelectorAll('.product');

            buttons.forEach(function (button) {
                button.addEventListener('click', function () {
                    let filterGroup = button.getAttribute('data-group');
                    let filterValue = button.getAttribute('data-filter');

                    // Toggle active class
                    button.classList.toggle('active');

                    // Collect all active filters
                    let activeFilters = {};
                    productList.querySelectorAll('button.active').forEach(function (activeButton) {
                        let group = activeButton.getAttribute('data-group');
                        let value = activeButton.getAttribute('data-filter');
                        if (!activeFilters[group]) {
                            activeFilters[group] = [];
                        }
                        activeFilters[group].push(value);
                    });

                    // Filter products
                    products.forEach(function (product) {
                        let filterData = JSON.parse(product.getAttribute('data-filters'));
                        let show = true;
                        for (let group in activeFilters) {
                            if (!filterData[group]) {
                                show = false;
                                break;
                            }
                            let productValues = filterData[group];
                            if (!activeFilters[group].some(value => productValues.includes(value))) {
                                show = false;
                                break;
                            }
                        }
                        product.style.display = show ? '' : 'none';
                    });

                    buttons.forEach(function (btn) {
                        let group = btn.getAttribute('data-group');
                        let value = btn.getAttribute('data-filter');
                        let hasResults = Array.from(products).some(function (product) {
                            let filterData = JSON.parse(product.getAttribute('data-filters'));
                            if (!filterData[group]) return false;
                            let productValues = filterData[group];
                            return productValues.includes(value) && product.style.display !== 'none';
                        });
                        btn.disabled = !hasResults;
                    });
                });
            });
        });
    });
});
